if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        document.body.classList.remove('modal-open');
        super.hide();
      }

      show(opener) {
        document.body.classList.add('modal-open');
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const opener = this.openedBy;
        const openedId = opener ? opener.getAttribute('data-media-id') : null;

        this.querySelectorAll('[data-media-id]').forEach((el) =>
          el.classList.remove('active')
        );

        if (!openedId) return;

        const activeMedia = this.querySelector(`[data-media-id="${openedId}"]`);
        if (!activeMedia) return;

        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({ block: 'center', inline: 'center' });

        const container = this.querySelector('[role="document"]');
        if (container && activeMedia.width && container.clientWidth) {
          container.scrollLeft = Math.max(
            0,
            (activeMedia.width - container.clientWidth) / 2
          );
        }

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMedia.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }

        this.dispatchEvent(
          new CustomEvent('hafa:modal-open', {
            bubbles: true,
            detail: { mediaId: openedId },
          })
        );
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('product-modal');
  if (!modal) return;

  const content = modal.querySelector('.product-media-modal__content');
  if (!content) return;

  // Nur EIN Satz Pfeile erzeugen
  let nav = modal.querySelector('.product-modal__nav');
  if (!nav) {
    nav = document.createElement('div');
    nav.className = 'product-modal__nav';
    nav.innerHTML = `
      <button class="product-modal__arrow product-modal__arrow--prev" aria-label="Vorheriges Bild">‹</button>
      <button class="product-modal__arrow product-modal__arrow--next" aria-label="Nächstes Bild">›</button>
    `;
    modal.appendChild(nav);
  }

  const prevBtn = nav.querySelector('.product-modal__arrow--prev');
  const nextBtn = nav.querySelector('.product-modal__arrow--next');
  const images = Array.from(content.querySelectorAll('[data-media-id]'));
  let currentIndex = 0;

  const updateActive = (i) => {
    images.forEach((el, idx) =>
      el.classList.toggle('active', idx === i)
    );
    currentIndex = i;
  };

 prevBtn.addEventListener('click', (e) => {
  e.preventDefault();
  e.stopImmediatePropagation();
  e.stopPropagation();
  if (!images.length) return;
  updateActive((currentIndex - 1 + images.length) % images.length);
});

nextBtn.addEventListener('click', (e) => {
  e.preventDefault();
  e.stopImmediatePropagation();
  e.stopPropagation();
  if (!images.length) return;
  updateActive((currentIndex + 1) % images.length);
});



  modal.addEventListener('hafa:modal-open', (e) => {
    const mediaId = e.detail.mediaId;
    const index = images.findIndex(
      (img) => img.dataset.mediaId === mediaId
    );
    updateActive(index >= 0 ? index : 0);
    nav.style.display = images.length > 1 ? '' : 'none';
  });

  document.addEventListener('keydown', (e) => {
    if (!modal.classList.contains('open')) return;
    if (e.key === 'Escape') modal.hide();
    if (e.key === 'ArrowLeft') prevBtn.click();
    if (e.key === 'ArrowRight') nextBtn.click();
  });
});

// === Shopify Dawn: Scroll- und Overflow-Hard-Fix ===
document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('product-modal');
  if (!modal) return;

  const html = document.documentElement;
  const body = document.body;

  const disableScroll = () => {
    html.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
    html.classList.add('has-scroll');
    body.classList.add('has-scroll');
  };

  const enableScroll = () => {
    html.style.overflow = '';
    body.style.overflow = '';
    html.classList.remove('has-scroll');
    body.classList.remove('has-scroll');
  };

  modal.addEventListener('modalOpen', disableScroll);
  modal.addEventListener('modalClose', enableScroll);

  // Fallback: falls Shopify open-Attribut nutzt
  new MutationObserver(() => {
    if (modal.hasAttribute('open')) disableScroll();
    else enableScroll();
  }).observe(modal, { attributes: true, attributeFilter: ['open'] });
});
